import type { FeatureSwitchQuery } from "../featureSwitches/FeatureSwitchQuery";
import type { FeatureSwitchesResponse } from "../featureSwitches/IFeatureSwitchManager";
import { mocksResponse } from "../utils/env";
import { API } from "./API";
import MockFeatureSwitchesResponse from "./mocks/getFeatureSwitches.json";

export async function getFeatureSwitches(
  query: FeatureSwitchQuery,
  classIdLocal?: string
): Promise<FeatureSwitchesResponse> {
  if (mocksResponse()) {
    // Dynamically mock the "class" field to match the classIDs being requested
    const response = MockFeatureSwitchesResponse as FeatureSwitchesResponse & { [`class`]: Record<string, string> };
    if (classIdLocal !== undefined) {
      response[classIdLocal as `class-${string}`] = response.class;
      response.community = {};
    } else {
      response.class = {};
    }
    return response;
  }
  // @ts-expect-error The returned typed doesn't correspond
  return await API.call({
    method: "get",
    path: "/api/featureSwitch",
    // @ts-expect-error TODO: Type mismatch. The endpoint doesn't mention query params.
    query,
  });
}
